var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnorderedList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "#6C737F",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.21875 13.1875C6.4925 13.1875 5.90625 13.7737 5.90625 14.5C5.90625 15.2263 6.4925 15.8125 7.21875 15.8125C7.945 15.8125 8.53125 15.2263 8.53125 14.5C8.53125 13.7737 7.945 13.1875 7.21875 13.1875ZM7.21875 7.9375C6.4925 7.9375 5.90625 8.52375 5.90625 9.25C5.90625 9.97625 6.4925 10.5625 7.21875 10.5625C7.945 10.5625 8.53125 9.97625 8.53125 9.25C8.53125 8.52375 7.945 7.9375 7.21875 7.9375ZM7.21875 18.4375C6.4925 18.4375 5.90625 19.0325 5.90625 19.75C5.90625 20.4675 6.50125 21.0625 7.21875 21.0625C7.93625 21.0625 8.53125 20.4675 8.53125 19.75C8.53125 19.0325 7.945 18.4375 7.21875 18.4375ZM9.84375 20.625H22.0938V18.875H9.84375V20.625ZM9.84375 15.375H22.0938V13.625H9.84375V15.375ZM9.84375 8.375V10.125H22.0938V8.375H9.84375Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnorderedList);
export default __webpack_public_path__ + "static/media/unordered-list.7c7a8ac437c4818605cbbd32e8d4737f.svg";
export { ForwardRef as ReactComponent };